export function getToken() {
    return window.localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)
}

export function setToken(token) {
    return localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, token)
}

export function removeToken() {
    localStorage.removeItem(process.env.VUE_APP_TOKEN_KEY)
}

export function getLastEmail() {
    return localStorage.getItem(process.env.VUE_APP_LAST_EMAIL_KEY)
}

export function setLastEmail(email) {
    return localStorage.setItem(process.env.VUE_APP_LAST_EMAIL_KEY, email)
}
